<template>
  <el-dialog
    class="rc-dialog"
    title="导入退休用户"
    :visible.sync="dialogInfo.show"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="30%"
  >
    <el-form
      class="curdForm"
      ref="curdForm"
      size="small"
      label-position="right"
      label-width="100px"
    >
      <el-form-item><span>请选择匹配方式</span></el-form-item>
      <el-form-item>
        <butn class="w_160" btntype="primary" title="姓名+出生年月匹配" @click="showImportDialog(1)"></butn>
      </el-form-item>
      <el-form-item>
        <butn class="w_160" btntype="primary" title="手机号码匹配" @click="showImportDialog(2)"></butn>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    showImportDialog(type) {
      this.$emit("close", true);
      this.$emit("showImportDialog", type);
    },
    closeDialog() {
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
  .curdForm {
    text-align: center;
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .w_160 {
    width: 160px;
  }
</style>
